/*------------------------------------*\
    MODULES
\*------------------------------------*/
import ModalVideo from 'modal-video';

/*------------------------------------*\
    VIDEO MODAL
\*------------------------------------*/
class VideoModal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let elemId = self.elem.getAttribute('id');
        let videoSource = self.elem.getAttribute('data-video-source');

        new ModalVideo(`#${elemId}`, {channel: videoSource});
    }
}

export default VideoModal;
